import React from "react";
// import { Formik, Form } from "formik";
// import { Button, Modal } from "react-bootstrap";
import logo from "../images/familee_tree_logo.svg";
import { Link } from "react-router-dom";
const SignUp = () => {
  return (
    <React.Fragment>
      <div className="login-page">
        <div className="login-container">
          <img src={logo} alt="FamileeTree" className="logo" />
          <form className="login-form">
            {/* <h2>Login</h2> */}
            <div className="input-group">
              <label htmlFor="firstName">First Name</label>
              <input type="text" id="firstName" name="firstName" required/>
            </div>
            <div className="input-group">
              <label htmlFor="lastName">Last Name: </label>
              <input type="text" id="lastName" name="lastName" required/>
            </div>
            <div className="input-group">
              <label htmlFor="emailId">Email Address: </label>
              <input type="text" id="emailId" name="emailId" required/>
            </div>
            <div className="input-group">
              <label htmlFor="mobileNumber">Phone: </label>
              <input type="text" id="mobileNumber" name="mobileNumber" required/>
            </div>
            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                required
              />
            </div>
            <button type="submit">Sign Up</button>

          </form>
        <Link to="/login">Login</Link>
        </div>
      </div>
    </React.Fragment>
  );
};
export default SignUp;
